import { useEffect, useMemo, useRef, useState } from 'react';
import { ArrowRight, Wand2 } from 'lucide-react';
import ThreeDCanvas from './ThreeDCanvas';
import './Hero.css';
import { useSettings } from '../settings';

function Hero({ active = true, deferCanvas = false, onStartProject }) {
  const sectionRef = useRef(null);
  const { t } = useSettings();
  const titleKeys = useMemo(() => [
    'hero.title',
    'hero.titleVariant1',
    'hero.titleVariant2',
    'hero.titleVariant3',
  ], []);
  const [titleIndex, setTitleIndex] = useState(0);
  const [canvasReady, setCanvasReady] = useState(false);

  useEffect(() => {
    let delayId = 0;
    let firstFrame = 0;
    let secondFrame = 0;

    setCanvasReady(false);
    const mountCanvas = () => {
      firstFrame = window.requestAnimationFrame(() => {
        secondFrame = window.requestAnimationFrame(() => setCanvasReady(true));
      });
    };

    if (deferCanvas) {
      delayId = window.setTimeout(mountCanvas, 340);
    } else {
      mountCanvas();
    }

    return () => {
      if (delayId) window.clearTimeout(delayId);
      if (firstFrame) window.cancelAnimationFrame(firstFrame);
      if (secondFrame) window.cancelAnimationFrame(secondFrame);
    };
  }, [deferCanvas]);

  useEffect(() => {
    if (!active) return undefined;
    const intervalId = window.setInterval(() => {
      setTitleIndex((currentIndex) => (currentIndex + 1) % titleKeys.length);
    }, 4000);
    return () => window.clearInterval(intervalId);
  }, [active, titleKeys.length]);

  return (
    <section id="home" ref={sectionRef} className="hero-ads">
      {/* 3D AI Ads Creation Hub Scene */}
      <div className="hero-canvas-container" aria-hidden="true">
        {canvasReady && <ThreeDCanvas active={active} />}
      </div>

      {/* Hero copy beneath the 3D scene */}
      <div className="hero-ads-content">
        <h1 className="hero-ads-title">
          <span key={titleKeys[titleIndex]} className="hero-ads-title-text">
            {t(titleKeys[titleIndex])}
          </span>
        </h1>

        <p className="hero-ads-sub">
          {t('hero.subtitle')}
        </p>

        <div className="hero-ads-actions">
          <button
            onClick={onStartProject}
            className="hero-ads-btn hero-ads-btn--primary"
            type="button"
          >
            <Wand2 size={18} /> {t('hero.start')} <ArrowRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
}

export default Hero;
